<template>
	<div class="page_intro">
		<section class="link-card-section">
			<div class="card-box">
				<div class="card-contents">
					<div class="link-title">
						{{ linkTitle }}
					</div>
					<div class="introduction">
						<p class="lead" v-html="lead"></p>
						<p v-html="introduction"></p>
						<div class="link">
							<page-link-button :link="pageLink" />
						</div>
					</div>
				</div>
				<div class="contents-image">
					<img :src="contentsImage" />
				</div>
			</div>
		</section>
	</div>
</template>

<script>
// @ is an alias to /src
import PageLinkButton from '@/components/common/PageLinkButton.vue';
export default {
	name: 'page-intro',
	components: {
		PageLinkButton,
	},
	props: {
		contentsImage: String,
		linkTitle: String,
		lead: String,
		introduction: String,
		pageLink: String,
	},
};
</script>

<style lang="scss" scoped>
.page_intro {
	&:nth-child(even) {
		.link-card-section {
			&:before {
				left: 0;
			}
		}
		.card-box {
			flex-direction: row-reverse;
		}
		.card-contents {
			left: 0;
		}
		.link-title {
			left: 0;
			right: unset;
		}

		.introduction {
			&:before {
				top: 1em;
				right: -115px;
				left: auto;
			}
		}
	}
}
.link-card-section {
	max-width: 1160px;
	width: 100%;
	height: 100%;
	margin: 0 auto;
	margin-bottom: 150px;
	position: relative;
	@media print, screen and (max-width: 1160px) {
		max-width: 90%;
		border: 2px solid #543193;
	}
	&:before {
		@media print, screen and (min-width: 1161px) {
			max-width: 1000px;
			content: '';
			display: block;
			position: absolute;
			top: 0;
			right: 0;
			width: 100%;
			height: 100%;
			border: 2px solid #543193;
		}
	}
}
.card-box {
	display: flex;
	position: relative;
	@media print, screen and (max-width: 1160px) {
		display: block;
	}
}
.contents-image {
	position: relative;
	transform: translate(0px, 50px);
	z-index: -1;
	max-width: 630px;
	width: 100%;
	@media print, screen and (max-width: 1160px) {
		margin: 0 auto;
		transform: scaleX(1.1);
		overflow: hidden;
		margin-bottom: 50px;
	}
}
.card-contents {
	width: 40%;
	position: absolute;
	right: 0;
	height: 100%;
	@media print, screen and (max-width: 1160px) {
		width: 100%;
		position: relative;
	}
}
.link-title {
	font-family: 'Noto Serif JP';
	background-color: #543193;
	color: #fff;
	display: inline-block;
	position: absolute;
	right: 0;
	padding: 0.5em 2.5em;
	@media print, screen and (max-width: 1160px) {
		position: relative;
	}
}
.introduction {
	font-family: 'Noto Serif JP';
	font-size: 19px;
	line-height: 2em;
	position: relative;
	margin: 0 30px;
	@media print, screen and (min-width: 1161px) {
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
	@media print, screen and (max-width: 1160px) {
		margin-bottom: 50px;
		margin: 30px 1.5em;
	}
	&:before {
		@media print, screen and (min-width: 1161px) {
			content: '';
			width: 100px;
			height: 4px;
			background-color: #929292;
			display: block;
			position: absolute;
			top: 1em;
			left: -175px;
		}
	}
	p {
		margin: 0;
		line-height: calc(49 / 19);
		@media screen and (max-width: 1160px) {
			font-size: 15px;
			line-height: calc(73 / 29);
			text-align: center;
		}
		@media print, screen and (max-width: 520px) {
			text-align: left;
		}
		&.lead {
			font-size: 20px;
			line-height: calc(73 / 40);
			margin-bottom: 1em;
			@media print, screen and (min-width: 1161px) {
				font-size: 26px;
			}
		}
	}
}
.link {
	margin-top: 45px;
	@media print, screen and (max-width: 1160px) {
		margin-top: 30px;
		text-align: center;
	}
	@media print, screen and (max-width: 520px) {
		text-align: left;
	}
}
</style>
